<template>
  <div class="slide_weapper">
    <div class="gallery_wrapper">
      <GallerySm :pageData="pageData" />
    </div>
    <div class="slide_content" :class="subPage ? 'slide_content--border' : ''">
      <h2 class="slide_heading">{{ pageData?.name }}</h2>
      <p>
        {{ pageData?.shortDesc }}
      </p>

      <router-link
        v-if="subPage"
        class="more_details"
        :to="{
          name: 'seatingPage',
          params: { purlId: $route.params?.purlId, pageId: box?.id },
        }"
      >
        <button
          v-if="insidePopup"
          data-bs-dismiss="modal"
          type="button"
          class="btn btn-primary btn-lg px-4 gap-3"
        >
          MORE DETAILS
        </button>
        <button v-else type="button" class="btn btn-primary btn-lg px-4 gap-3">
          MORE DETAILS
        </button></router-link
      >
    </div>
  </div>
</template>

<script>
import GallerySm from "@/components/GallerySm";

export default {
  name: "CarouselCard",
  components: {
    GallerySm,
  },
  props: ["box", "subPage", "insidePopup"],
  computed: {
    pageData() {
      return this.box?.extraData;
    },
  },
  methods: {
    truncate: (t) => {
      if (!t) return;
      return t.replace(/^(.{400}[^\s]*).*/, "$1 ...");
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery_wrapper {
  flex: 0 1 auto;
}
.slide {
  &_weapper {
    // background-image: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.17);
    // background: white;
    border-radius: 20px;
    overflow: hidden;
    // margin: 1em;
    height: 100%;
    display: flex;
    flex-direction: column;
    // margin: 1em auto;
  }
  &_content {
    padding: 20px;
    @media (max-width: 800px) {
      padding: 20px 40px;
    }
    // height: 450px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    background: white;
    // &--border {
    //   &::after {
    //     content: "";
    //     background: #efefef;
    //     width: 100%;
    //     height: 1px;
    //     position: absolute;
    //     bottom: 70px;
    //     left: 50%;
    //     transform: translateX(-50%);
    //   }
    // }
    h2 {
      font-family: Formula1-Display-Bold;
      font-size: 20px;
      color: #008e97;
      line-height: 1.6em;
      font-weight: 500;
      text-transform: uppercase;
    }
    p {
      font-family: TitilliumWeb-Regular;
      font-size: 12px;
      color: #000000;
      line-height: 19px;
      font-weight: 400;
    }
    .more_details {
      margin-top: auto;
      button {
        color: $color-highlight !important;
        width: 100%;
      }
    }
  }
}
</style>